import Vue from 'vue';
// import DrPicker from './DrPicker.vue';
// import $ from 'jquery';
import { store } from './store/index';

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import TnTravelResults from "./components/TnTravelResults";
import TnTravelFilter from "./components/TnTravelFilter";
import TnTravelFinder from "./components/TnTravelFinder";
import TnTravelPagination from "./components/TnTravelPagination";

Vue.config.productionTip = false;


// const overlayWrapper = document.body;
// const overlayEl = window.document.createElement('DIV');
// overlayWrapper.appendChild(overlayEl);
//
// let target = window.document.getElementById('dr-picker');
// const mountPoint = window.document.createElement('DIV');
// mountPoint.classList.add('dr-picker-wrapper');
// target.appendChild(mountPoint);
// let component = new Vue(DrPicker);
// component.$mount(mountPoint);
// let dateFromEl = window.document.getElementById('date_from');
// let dateToEl = window.document.getElementById('date_to');
// console.log('INIT');
// $('#date_from').on('click', function () {
//     component.show({
//         mode: 'range-start',
//         range: {
//             start: component.parseDate(dateFromEl.value),
//             end: component.parseDate(dateToEl.value)
//         }
//     });
// });
// $('#date_to').on('click', function () {
//     component.show({
//         mode: 'range-end',
//         range: {
//             start: component.parseDate(dateFromEl.value),
//             end: component.parseDate(dateToEl.value)
//         }
//     });
// });
//
// component.$on('update:range', function (range) {
//     console.log('Range: ', range);
//     dateFromEl.value = component.formatDate(range.start);
//     dateToEl.value = component.formatDate(range.end);
// });


export const init = () => {
    console.log(`
 _______  _____  _      _    _  ________  __     .-´´\`\`-.     ____   __
|__   __||  ___|| |    | |  | ||__    __||  |  ´------.  \`\\  |    \\ |  |
   | |   | |__  | |    | |  | |   |  |   |  |  ____   |    | |  \\  \\|  |
   | |   | |___ | |___ | |__| |   |  |   |  | |    |  |    | |  |\\  \\  |
   |_|   |_____||_____||______|   |__|   |__| \`   /   /    | |__| \\____|
                                               \\´   .´    /
                                                 -´___,-´`);
};

export const widgets = {

    TnTravelResults: function (el, options) {
        const widget = new Vue({store, ...TnTravelResults, propsData: options || {}});
        widget.$mount(el);
        return widget;
    },
    
    TnTravelFilter: function (el, options) {
        const widget = new Vue({store, ...TnTravelFilter, propsData: options || {} });
        widget.$mount(el);
        return widget;
    },

    TnTravelFinder: function (el, options) {
        const widget = new Vue({ store, ...TnTravelFinder, propsData: options || {} });
        widget.$mount(el);
        return widget;
    },

    TnTravelPagination: function (el, options) {
        const widget = new Vue({ store, ...TnTravelPagination, propsData: options || {} });
        widget.$mount(el);
        return widget;
    }

};
